/**
 * When adding a new CampaignObjective for new campaign, please also update the following files to ensure no broken functionality:
 *  - library/product-plans/lib/permissions/campaign.ts
 *  - appengine-routes/frontend-route/src/pages/CampaignsV2/common/global.ts
 * It to define the access permission for the new campaign objective (what is the minimum plan that the new objective should be available to).
 */
export enum CampaignObjective {
    REVIEWS = 'REVIEWS',
    RECOMMENDATIONS = 'RECOMMENDATIONS',
    EMPLOYEE_REVIEWS = 'EMPLOYEE_REVIEWS',
    ENGAGEMENT = 'ENGAGEMENT',
    BOOKINGS = 'BOOKINGS',
    WELCOME_NEW_CUSTOMERS = 'WELCOME_NEW_CUSTOMERS',
    REWARD_LOYAL_CUSTOMERS = 'REWARD_LOYAL_CUSTOMERS',
    REPEAT_BUSINESS = 'REPEAT_BUSINESS',
    ATOM_REFERRALS = 'ATOM_REFERRALS',
    REFERRALS = 'REFERRALS',
}

export enum CampaignSubjectKind {
    Person = 'Person',
    Story = 'Story',
    Employee = 'Employee',
    User = 'User',
}

export enum CampaignRuleQueryableEntity {
    CampaignEnrollment = 'CampaignEnrollment',
    Case = 'Case',
    Click = 'Click',
    Conversation = 'Conversation',
    GiftIntent = 'GiftIntent',
    Invoice = 'Invoice',
    Job = 'Job',
    Payment = 'Payment',
    Photo = 'Photo',
    Proposal = 'Proposal',
    Recommendation = 'Recommendation',
    Review = 'Review',
    Story = 'Story',
    Person = 'Person',
    Visit = 'Visit',
    PaymentTransaction = 'PaymentTransaction',
}

export enum CampaignRuleType {
    SINGLE = 'SINGLE',
    AGGREGATE = 'AGGREGATE',
}

export enum CampaignRuleCalcMethod {
    SUM = 'SUM',
    MEAN = 'MEAN',
    MEDIAN = 'MEDIAN',
    MODE = 'MODE',
}

export enum CampaignRuleFilterProperty {
    AMOUNT = 'amount',
    AMOUNT_AVERAGE = 'amount__average',
    AMOUNT_SUM = 'amount__sum',
    BALANCE = 'balance',
    BLOCKED = 'blocked',
    CAMPAIGN_ID = 'campaign_id',
    COMPANY = 'company',
    COMPLETE = 'complete',
    COMPLETED_AT = 'completed_at',
    COUNT = '_COUNT_',
    CREATED_AT = 'created_at',
    DELETED = 'deleted',
    DELETED_AT = 'deleted_at',
    EMAIL = 'email',
    ENDED = 'ended',
    ENDED_AT = 'ended_at',
    EXTERNAL_CREATED_AT = 'external_created_at',
    HAS_CONVERTED = 'has_converted',
    HAS_SHARES = 'has_shares',
    ID = 'id',
    IMMEDIATE_EXIT = 'immediate_exit',
    INITIAL_SOURCE = 'initial_source',
    LIFECYCLE_STAGE = 'lifecycle_stage',
    METADATA_CAMPAIGN_ID = 'metadata.nj_campaign',
    METADATA_CONTENT_HREF_VARIABLE = 'metadata.nj_string_value_href_variable',
    NAME = 'name',
    NETWORK = 'network',
    PAID = 'paid',
    PAID_AT = 'paid_at',
    PAUSED = 'paused',
    POSITION = 'position',
    PUBLISHED = 'published',
    RATING = 'rating',
    RATING_AVERAGE = 'rating__average',
    SCHEDULED_AT = 'scheduled_at',
    STATUS = 'status',
    STOPPED = 'stopped',
    SUCCESSFUL = 'successful',
    TAGS = 'tags',
    TOTAL = 'total',
    TOTAL_AVERAGE = 'total__average',
    TOTAL_SUM = 'total__sum',
    TRANSACTION_DATE = 'transaction_date',
    UPDATED_AT = 'updated_at',
}

export enum CampaignRuleOperator {
    GREATER_THAN_OR_EQUAL_TO = 'GREATER_THAN_OR_EQUAL_TO',
    GREATER_THAN = 'GREATER_THAN',
    EQUAL_TO = 'EQUAL_TO',
    LESS_THAN = 'LESS_THAN',
    LESS_THAN_OR_EQUAL_TO = 'LESS_THAN_OR_EQUAL_TO',
    NOT_EQUAL_TO = 'NOT_EQUAL_TO',
    CONTAINS = 'CONTAINS',
    DOES_NOT_CONTAIN = 'DOES_NOT_CONTAIN',
    IS_WITHIN_THE_LAST = 'IS_WITHIN_THE_LAST',
    IS_BEYOND_THE_LAST = 'IS_BEYOND_THE_LAST',
    IS_AFTER = 'IS_AFTER',
    IS_BEFORE = 'IS_BEFORE',
}

export enum DefaultCampaign {
    GET_REVIEWS = 'GET_REVIEWS',
    RECOMMENDATIONS = 'RECOMMENDATIONS',
    BOOKINGS = 'BOOKINGS',
    GET_REPEAT_BUSINESS = 'GET_REPEAT_BUSINESS',
    ATOM_REFERRALS = 'ATOM_REFERRALS',
    REFERRALS = 'REFERRALS',
}
